import { render, staticRenderFns } from "./OrganizationAlreadyRealName.vue?vue&type=template&id=1168f4d3&scoped=true&"
import script from "./OrganizationAlreadyRealName.vue?vue&type=script&lang=js&"
export * from "./OrganizationAlreadyRealName.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationAlreadyRealName.vue?vue&type=style&index=0&id=1168f4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168f4d3",
  null
  
)

export default component.exports